const EVIDENCE_ON_PUBLIC_EXCHANGE_DOCUMENT_TYPES = {
  STOCK_EXCHANGE_LISTING: {
    value: "stock_exchange_listing",
    readableName: "Stock Exchange Listing",
  },
  BLOOMBERG_REUTERS_REPORT: {
    value: "bloomberg_reuters_report",
    readableName: "Bloomberg Reuters Report",
  },
};

export const evidenceOnPublicExchangeDocumentTypesArray = Object.values(
  EVIDENCE_ON_PUBLIC_EXCHANGE_DOCUMENT_TYPES,
);
